<template>
    <div v-show="visible" class="modal-overlay">
        <div class="modal-container">
            <!-- Header -->
            <div class="modal-header">
                <img :src="prodDisData?.banner" alt="Header Image" class="header-image" />
                <div class="mask"></div>
                <img class="close-button" @click="closeModal" src="@/assets/images/common/close.png" alt="" srcset="">
                <span class="header-text">{{ prodDisData?.material }}（{{ prodDisData?.colour }}）</span>
            </div>

            <!-- Body -->
            <div class="modal-body notScroll">
                <div class="content-item" v-if="prodDisData?.material">
                    <h3 class="content-title">材质</h3>
                    <p class="content-text">{{ prodDisData.material }}</p>
                </div>

                <div class="content-item" v-if="prodDisData?.colour">
                    <h3 class="content-title">颜色</h3>
                    <p class="content-text">{{ prodDisData.colour }}</p>
                </div>

                <div class="content-item" v-if="prodDisData?.kg">
                    <h3 class="content-title">克重</h3>
                    <p class="content-text">{{ prodDisData.kg }}</p>
                </div>

                <div class="content-item" v-if="prodDisData?.silicon">
                    <h3 class="content-title">单硅/双硅</h3>
                    <p class="content-text">{{ prodDisData.silicon }}</p>
                </div>

                <div class="content-item" v-if="prodDisData?.force">
                    <h3 class="content-title">离型力水平</h3>
                    <p class="content-text">{{ prodDisData.force }}</p>
                </div>
                <!-- Tags -->
                <div class="tags">
                    <h3>推荐应用</h3>
                    <div class="tag" v-for="(tag, index) in prodDisData?.applications_info" :key="index"
                        @click="tagClicked(tag)">
                        {{ tag.name }}
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer">
                <button class="action-button" @click="buttonAction">
                    <img src="@/assets/images/common/preview.png" alt="Button Image" class="button-image" />
                    <span class="button-text">{{ buttonText }}</span>
                </button>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        prodDisData: [Object, Array],

        buttonImage: String,
        buttonText: String
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        tagClicked(tag) {
            this.$emit('tag-click', tag);
        },
        buttonAction() {
            // console.log(' ---:',this.prodDisData?.pdf?.url);
            let pdfUrl = this.prodDisData?.pdf?.url;
           if(pdfUrl)this.$dataStatistics('click', '预览:' + pdfUrl);
            this.$emit('button-click', pdfUrl);
        }
    }
};
</script>
  
<style scoped lang="less">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

}

.modal-container {
    border-radius: 10px;
    overflow: hidden;
    width: 300px;
}

.modal-header {
    position: relative;

    overflow: hidden;
    width: 300px;
    height: 160px;
}
.mask{
    position: absolute;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
}

.header-image {
    position: absolute;
    width: 300px;
    height: 160px;
    display: block;
    border-radius: 10px 10px 0 0;
}

.close-button {
    position: absolute;
    top: 17px;
    right: 17px;
    width: 24px;
    height: 24px;
    cursor: pointer;
}

.header-text {
    position: absolute;
    left: 16px;
    bottom: 12px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 26px;
    font-weight: bold;
}

.modal-body {
    padding: 16px;
    height: 280px;
    overflow-y: scroll;
    background-color: #ffffff;
}

.content-item {
    margin-bottom: 16px;
}

.content-title {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
}

.content-text {
    font-size: 14px;
    color: #5D5D61;
    line-height: 20px;
    margin-top: 8px;
}

.tags {
    margin-top: 20px;
}

.tag {
    display: inline-block;
    background: #F3F3F3;
    padding: 5px 12px;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 8px;
    font-size: 14px;
    color: #5D5D61;
    margin-top: 5px;
}

.tags h3 {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    margin-bottom: 8px;
}

.modal-footer {
    padding: 12px 60px;
    text-align: center;
    background-color: #ffffff;
    border-top: 1px solid #E5E5E5;
}

.action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    background: #0059A3;
    border-radius: 4px 4px 4px 4px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #FFFFFF;
}

.button-image {
    width: 22px;
    height: 20px;
    margin-right: 10px;
}
</style>